<template>
  <div>
    <!-- SNACKBAR DE MODIFICACION DE ORDENES -->
    <v-snackbar :color="colorsnackbarAlert" v-model="snackbarAlert" :timeout="timeout" top>
      <v-icon>mdi-message</v-icon>
      {{ SnackbarTextAlert }}

      <template v-slot:action="{ attrs }">
        <v-btn color="black" text v-bind="attrs" @click="snackbarAlert = false">
          Cerrar
        </v-btn>
      </template>
    </v-snackbar>


    <v-form ref="formDatosGenerales" lazy-validation>
      <v-row>
        <v-col cols="12" lg="3">
          <v-text-field :value="`Sesión ${datosTema.orden_clase}/${totalTemas}`" readonly></v-text-field>
        </v-col>
        <v-col cols="12" lg="3">
          <v-text-field label="Docente" v-model="datosSA.docente" disabled></v-text-field>
        </v-col>
        <v-col cols="12" lg="3">
          <v-text-field label="Tutor" v-model="datosSA.tutor" disabled></v-text-field>
        </v-col>
        <v-col cols="12" lg="3">
          <v-text-field label="Fecha de aplicación" disabled></v-text-field>
        </v-col>

        <v-col cols="12" lg="2">
          <v-text-field label="Tiempo de aplicación" v-model="datosSA.tiempo_aplicacion"></v-text-field>
        </v-col>
        <v-col cols="12" lg="5">
          <v-textarea rows="1" label="Enfoques Transversales" :rules="[rul.required]"
            v-model="datosSA.enfoques_transversales"></v-textarea>
        </v-col>
        <v-col cols="12" lg="5">
          <v-textarea rows="3" label="Objetivos" :rules="[rul.required]" v-model="datosSA.objetivos"></v-textarea>
        </v-col>
      </v-row>
      <!-- Competencias -->

      <!-- Competencias -->
      <v-sheet color="grey lighten-2" height="100px" class="" v-if="readyloadProg">
        <!-- <v-sheet color="grey lighten-2" height="100px" class=""> -->
        <v-skeleton-loader class="mx-auto" width="auto" type="card-avatar"></v-skeleton-loader>
      </v-sheet>

      <v-row v-if="listCompetencias.length == 0 && !readyloadProg">
        <v-col cols="12">
          <v-alert color="error" icon="$warning">
            No existen competencias asociadas a este tema!
          </v-alert>
        </v-col>
      </v-row>

      <v-row v-if="!readyloadProg">
        <v-col cols="12">
          <v-card outlined>
            <v-card-title class="d-flex justify-center text-subtitle-2">
              Leyenda
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="12" class="d-flex justify-center">
                  <div class="leyenda-comptencia mx-2">
                  </div>
                  Competencia
                  <div class="leyenda-capacidad mx-2">
                  </div>
                  Capacidades
                  <div class="leyenda-desempeno mx-2">
                  </div>
                  Desempeños
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" v-for="(item01, index01) in listCompetencias" :key="index01">
          <!--  Item01  RENGLONES DE COMPETENCIAS -->
          <v-row v-for="(item02, index02) in item01.competencias" :key="index02">
            <v-col cols="12">
              <v-card outlined>
                <v-card-title class="d-flex text-subtitle-2">
                  Competencias
                </v-card-title>
                <v-card-text>
                  <v-row class="competencia white--text" dense>
                    <v-col cols="2" class="d-flex justify-center">
                      <v-checkbox dark :value="item02.id" v-model="checkedCompentencias"
                        @change="EventCompetencia($event, index01, item02.id, index02)" class="mx-2">
                      </v-checkbox>
                    </v-col>
                    <v-col cols="10" class="d-flex align-center">
                      <i class="fas fa-chevron-right fa-lg ico_competencia"></i>
                      {{ item02.descripcion }}
                    </v-col>


                    <v-col cols="12" v-if="item02.capacidades">
                      <v-card outlined>
                        <v-card-title class="d-flex text-subtitle-2">
                          Capacidades
                        </v-card-title>
                        <v-card-text>
                          <v-row v-for="(item03, index03) in item02.capacidades" :key="index03"
                            class="capacidades white--text" dense>
                            <v-col cols="2" class="d-flex justify-center">
                              <!--  event, indexPrincipal, id_competencia_area, indexComp, indexCap  -->
                              <v-checkbox dark :value="item03.id" class="mx-2" v-model="checkedCapacidades" @change="
                                EventCapacidad(
                                  $event,
                                  index01,
                                  item03.id,
                                  index02,
                                  index03
                                )
                                ">
                              </v-checkbox>
                            </v-col>

                            <v-col cols="10" class="d-flex justify-start align-center">
                              <i class="fas fa-caret-right fa-lg ico_capacidad"></i>
                              {{ item03.descripcion }}
                            </v-col>

                            <!--
                                    /////////////////////////////////
                                        DESEMPEÑO O INIDICADORES
                                    /////////////////////////////////
                                -->

                            <!-- Imten03 DETALLE DE INDICADORES O DESEMPEÑO -->

                            <v-col cols="12" v-if="item03.indicador">
                              <v-card>
                                <v-card-title class="d-flex text-subtitle-2">
                                  Desempeños
                                </v-card-title>
                                <v-card-text>
                                  <v-row dense class="desempeno" v-for="(item04, index04) in item03.indicador"
                                    :key="index04">
                                    <v-col cols="2" class="d-flex justify-center ">
                                      <!--  event Indicadores o Desompeños,  indexPrincipal, id_competencia_area, indexComp, indexCap  -->
                                      <v-checkbox :value="item04.id" class="mx-2" v-model="checkedIndicadores"
                                        @change="EventIndicador($event, item02, item03, item04)">
                                      </v-checkbox>
                                    </v-col>

                                    <v-col cols="10" class="d-flex justify-start align-center">
                                      <i class="fas fa-angle-double-right fa-lg ico_indicador"></i>
                                      {{ item04.descripcion }}
                                    </v-col>
                                  </v-row>
                                </v-card-text>
                              </v-card>

                            </v-col>
                          </v-row>
                        </v-card-text>
                      </v-card>


                    </v-col>
                  </v-row>

                </v-card-text>
              </v-card>

            </v-col>



            <!--  CAPACIADADES INSERT  v-model= "checkCapacidad" -->


            <!-- Imten03 DETALLE DE CAPACIADADES -->



            <!-- FIN DE CAPACIDADES -->
          </v-row>
        </v-col>
      </v-row>

      <v-row v-if="!readyloadProg">
        <v-col class="d-flex justify-end mt-4">
          <ButtonComp @click="SaveDatosGenerales" text-button="Guardar" icon-but="fas fa-save" normal-button />
        </v-col>
      </v-row>
    </v-form>

    <v-overlay :value="guardando">
      <v-progress-circular indeterminate size="130">
        <h3>Guardando...</h3>
      </v-progress-circular>
    </v-overlay>

  </div>
</template>

<script>
import axios from "@/helpers/axios";
import { mapMutations, mapGetters, mapActions } from "vuex";
import ButtonComp from '../../../../../components/ComponentsEst/TableButtonComp.vue';
export default {
  name: "FormSesionAprendizaje",
  components: {
    ButtonComp
  },

  props: {
    parametros: {
      type: Object,
    },
    estadoComp: {
      type: Boolean,
    },
  },

  data: () => ({
    //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
    paramComponente: { id_submodulo: 141, id_modulo: 5 }, //sud_modulo y modulo
    guardando: false,
    datoLogin: sessionStorage, // variables de sesion del usuario
    ////////////////////////////////////////////////////////
    readyloadProg: true,
    test: false,
    datosSA: {},
    datosTema: {},
    totalTemas: -1,
    listCompetencias: [],
    listIndicadores: [],

    checkedCompentencias: [],
    checkedCapacidades: [],
    checkedIndicadores: [],

    // PROPIEDADES PARA ALERTA
    colorsnackbarAlert: "green",
    snackbarAlert: false,
    timeout: 2000,
    SnackbarTextAlert: "",

    //////////////////////////////////

    //validaciones de formulario
    rul: {
      required: (value) => !!value || "Campo Requerido",
      inputReq: (value) => !!value || "Campo Requerido",
      selectReq: (value) => !!value || "Debe seleccionar un campo de la lista",
      email: (value) =>
        /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.([a-zA-Z]{2,4})+$/.test(value) ||
        "El correo es incorrecto",
      min4: (v) => (v || "").length >= 4 || "Mínimo 4 caracteres",
      min6: (v) => (v || "").length >= 6 || "Mínimo 6 caracteres",
      min8: (v) => (v || "").length >= 8 || "Mínimo 8 caracteres",
      max10: (v) => (v || "").length <= 10 || "Máximo 10 caracteres",
      max11: (v) => (v || "").length <= 11 || "Máximo 11 caracteres",
      max12: (v) => (v || "").length <= 12 || "Máximo 12 caracteres",
      max20: (v) => (v || "").length <= 20 || "Máximo 20 caracteres",
      max30: (v) => (v || "").length <= 30 || "Máximo 30 caracteres",
      max50: (v) => (v || "").length <= 50 || "Máximo 50 caracteres",
      max60: (v) => (v || "").length <= 60 || "Máximo 60 caracteres",
      max100: (v) => (v || "").length <= 100 || "Máximo 100 caracteres",
      max150: (v) => (v || "").length <= 150 || "Máximo 150 caracteres",
    },
  }),

  computed: {
    ...mapGetters("login", ["componenteEvento"]),
  },

  created() {
    this.actualizarParamentro();
  },

  mounted() {
    this.LoadMain();
  },

  watch: {
    // cada vez que la pregunta cambie, esta función será ejecutada
    estadoComp() {
      if (this.estadoComp) {
        this.LoadMain();
      } else {
        //this.parametros = {}
        this.readyloadProg = true;
        this.LimpiarForm();
      }
    },
  },

  methods: {
    ...mapActions("login", ["parametroComponente"]),

    //  ------- MENSAJE DE SISTEMA  --------
    ...mapMutations("mensajeSis", ["setEnviarMens"]),

    actualizarParamentro() {
      this.parametroComponente(this.paramComponente);
    },

    async LoadMain() {
      this.LimpiarForm();

      setTimeout(async () => {
        this.readyloadProg = false;
      }, 1000);

      this.datosTema = this.parametros.tema;
      this.totalTemas = this.parametros.totalTemas;

      if (this.parametros.evento == "add") {
        this.datosSA.tiempo_aplicacion = "90 minutos";
        this.GetDocente();
        this.GetAllCompetencias();
      }

      if (this.parametros.evento == "edit") {
        this.EditItem(this.parametros.id_clase);
      }
    },

    async EditItem(id_clase) {
      try {
        await this.GetAllCompetencias();

        let resp = await axios.get(
          `/academico/sesionAprendizaje/clase/${id_clase}/`
        );

        if (resp.data) {
          this.datosSA = resp.data;
          this.GetDocente();
          if (this.datosSA.indicadores.length >= 1) {
            this.MostrarIndicadoresSeleccionados();
          }
          this.$emit("reloadComp", this.datosSA.id);
        }
      } catch (e) {
        this.setEnviarMens({
          tipo: e.data.messageT,
          mensaje: `${e.data.message}`,
          tiempo: null,
        });
      }
    },

    async GetDocente() {
      try {
        var resp = await axios.get(
          `/academico/sesionAprendizajeProg/getPersonaDocente/${this.datoLogin.id_colegio}/${this.datoLogin.id_persona}/`
        );
        if (resp.data) {
          let docente = resp.data;
          this.datosSA.docente = `${docente.nombre_persona} ${docente.ape1_persona} ${docente.ape2_persona}`;
          this.datosSA.id_docente = docente.id_persona;
        }
      } catch (error) {
        console.log(error);
        this.setEnviarMens({
          tipo: "E",
          mensaje: `Error al consultar datos de la programación del docente para la sesión de aprendizaje`,
          tiempo: null,
        });
      }
    },

    async GetAllCompetencias() {
      this.listCompetencias = [];

      const params = {
        id_colegio: this.datoLogin.id_colegio,
        id_curriculo: this.id_curriculo,
        id_ano_lectivo: this.datosTema.id_ano_lectivo,
        id_nivel: this.datosTema.id_nivel,
        id_grado: this.datosTema.id_grado,
        id_area: this.datosTema.id_area,
      };

      try {
        // CORRECTO
        let resp = await axios.post(
          `/administrativo/competencia/cs/all/`,
          params
        );
        this.listCompetencias = resp.data;
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    // CHECK DE COMPETENCIAS EVENTO
    //listar las  CAPACIDADES a dar click en una Competencia
    async EventCompetencia(
      event,
      indexPrincipal,
      id_competencia_area,
      indexComp,
      recargar = false
    ) {
      // event: si esta chequeado o NO la competencia (true, false)
      // indexPrincipal:  posicion del elemento del index Principal
      // id_competencia_area:  campo unico de la tabla competencia
      // indexComp: posicion del elemento de la compentencia
      if (recargar) {
        this.listCompetencias[indexPrincipal].competencias[
          indexComp
        ].capacidades = [];
      }

      if (event) {
        try {
          var resp = await axios.get(
            `/manager/capacidad/gall/${id_competencia_area}`
          );
          // let resp = await axios.get(`/administrativo/capacidad/listAllCapacidad/${id_competencia_area}`)
         
          if (resp.data.length == 0) {
            this.listCompetencias[indexPrincipal].competencias[
              indexComp
            ].capacidades = [];
          } else {
            this.listCompetencias[indexPrincipal].competencias[
              indexComp
            ].capacidades = resp.data;
          }
        } catch (error) {
          this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
        }
        //check es false
      } else {
        this.listCompetencias[indexPrincipal].competencias[
          indexComp
        ].capacidades = null;
      }
    },

    //listar las INDICADORES O DESEMPEÑO  a dar click en una Capacidad
    async EventCapacidad(
      event,
      indexPrincipal,
      id_capacidad,
      indexComp,
      indexCap
    ) {
      // event si esta checkqueado o NO la capacidad

      if (event) {
        try {
          // Listar los Indicadores o Desempeños
          var resp = await axios.get(`/manager/indicador/gall/${id_capacidad}`);
          /*     
                        let params = {
                            // id_curriculo: this.filtro.id_curriculo, 
                            id_competencia_area:null, 
                            id_mgr_capacidad:null, 
                            id_capacidad
                        }
                        var resp   = await axios.post(`/administrativo/indicador/listInd/`,params) 
                        */

          if (resp.data.length == 0) {
            this.com[indexPrincipal].competencias[indexComp].capacidades[
              indexCap
            ].indicador = [];
          } else {
            this.listCompetencias[indexPrincipal].competencias[
              indexComp
            ].capacidades[indexCap].indicador = resp.data;
          }
        } catch (error) {
          this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
          this.listCompetencias[indexPrincipal].competencias[
            indexComp
          ].capacidades[indexCap].indicador = [];
        }

        // Limpia los Indicadores Seleccionado
      } else {
        this.listCompetencias[indexPrincipal].competencias[
          indexComp
        ].capacidades[indexCap].indicador = null;
      }
    },

    async EventIndicador(event, competencia, capacidades, indicador) {
      if (event.length > 0 && event.find((i) => i == indicador.id)) {

        let items = {
          id_competencia: competencia.id,
          id_capacidad: capacidades.id,
          id_indicador: indicador.id,
          origin: indicador.origen,
        };
        this.listIndicadores.push(items);
      } else {
        let index = this.listIndicadores.findIndex(
          (item) => item.id_indicador === indicador.id
        );
        this.listIndicadores.splice(index, 1);
      }
    },

    async SaveDatosGenerales() {

      if (this.$refs.formDatosGenerales.validate()) {

        this.guardando = true;

        if (
          this.checkedCompentencias.length == 0 ||
          this.checkedCapacidades.length == 0 ||
          this.checkedIndicadores.length == 0
        ) {
          this.snackbarAlert = true;
          this.colorsnackbarAlert = "red";
          this.SnackbarTextAlert =
            "Selecciona al menos un grupo de competencia con sus indicadores";
          this.guardando = false;
          return false;
        }

        if (this.listIndicadores.length == 0) {
          this.setEnviarMens({
            tipo: "W",
            mensaje: `Dede de Seleccionar algún Desempeño para poder Guardar`,
            tiempo: 8000,
          });
          return false;
        }

        try {
          let res = {};
          this.datosSA.id_usuario = this.datoLogin.id;
          const params = {
            id_colegio: this.datoLogin.id_colegio,
            id_nivel: this.datosTema.id_nivel,
            id_grado: this.datosTema.id_grado,
            id_tema: this.datosTema.id_tema,
            id_clase: this.datosTema.id,
            id_area: this.datosTema.id_area,
            enfoques_transversales: this.datosSA.enfoques_transversales,
            tiempo_aplicacion: this.datosSA.tiempo_aplicacion,
            objetivos: this.datosSA.objetivos,
            indicadores: this.listIndicadores,
            id_docente: this.datosSA.id_docente,
          };

          if (this.parametros.evento == "edit") {
            res = await axios.put(
              `/academico/sesionAprendizaje/${this.datosSA.id}/`,
              params
            );
          }

          if (this.parametros.evento == "add") {
            res = await axios.post("/academico/sesionAprendizaje", params);
            if (res.data.messageT == "S") {
              this.datosSA.id = res.data.data.id;
              this.parametros.evento = "edit";
              this.$emit("reloadComp", this.datosSA.id, 2);
            }
          }

          this.setEnviarMens({
            tipo: res.data.messageT,
            mensaje: res.data.message,
            tiempo: 4000,
          });
          this.guardando = false;
        } catch (e) {
          console.log(e);
          this.setEnviarMens({
            tipo: "E",
            mensaje: `Error al guardar registro`,
            tiempo: 6000,
          });
        }
      }
    },

    async MostrarIndicadoresSeleccionados() {
      let competencias = [];
      let capacidades = [];
      this.listIndicadores = this.datosSA.indicadores;
      this.checkedIndicadores = this.listIndicadores.map((i) => i.id_indicador);

      // console.log([ ...new Set( this.listIndicadores.map( obj => obj.id_competencia) ) ], this.listIndicadores);
      for (let i = 0; i < this.listIndicadores.length; i++) {
        const indicador = this.listIndicadores[i];
        if (
          !competencias.find((element) => element == indicador.id_competencia)
        ) {
          competencias.push(indicador.id_competencia);
          let indexComp = this.listCompetencias[0].competencias.findIndex(
            (competencia) => competencia.id == indicador.id_competencia
          );
          await this.EventCompetencia(
            true,
            0,
            indicador.id_competencia,
            indexComp
          );
        }
        capacidades.push(indicador.id_capacidad);
      }

      this.listCompetencias[0].competencias.forEach((objeto, indiceObjeto) => {
        if (objeto.capacidades != null) {
          objeto.capacidades.forEach((capacidad, indiceCapacidad) => {
            if (capacidades.includes(capacidad.id)) {
              this.EventCapacidad(
                true,
                0,
                capacidad.id,
                indiceObjeto,
                indiceCapacidad
              );
            }
          });
        }
      });

      this.checkedCompentencias = competencias;
      this.checkedCapacidades = capacidades;
    },

    LimpiarForm() {
      this.datosSA = {
        id_usuario: sessionStorage.id,
        id: -1,
        id_nivel: -1,
        id_grado: -1,
        id_area: -1,
        id_tema: -1,
        id_clase: -1,
        tiempo_aplicacion: "",
        enfoques_transversales: "",
        objetivos: "",
        id_us_ing: null,
        id_us_mod: null,
        fec_us_ing: "",
        fec_us_mod: "",
        id_docente: null,
        id_tutor: null,
        indicadores: [],
      };

      this.$refs.formDatosGenerales.resetValidation();
      this.listIndicadores = [];
      this.checkedCompentencias = [];
      this.checkedCapacidades = [];
      this.checkedIndicadores = [];
    },
  },
};
</script>